import * as React from 'react';
import { PrimaryButton, Link } from 'office-ui-fabric-react/lib/index';
import classnames from 'classnames'
import Wrapper from './Wrapper'
import { clientLog, apiGetAccount } from '../util'

export interface Props {
    onSignIn: () => void;
}

export interface State {
}

export default class Setup extends React.Component<Props, State> {
    constructor(props, context) {
        super(props, context);
        this.state = {
        };
    }

    render() {
        const {
            onSignIn
        } = this.props;

        const {
        } = this.state;

        return (
            <Wrapper
                account={null}
                className={classnames("mm-view mm-message mm-setup")}>
                <p className="ms-font-xxl -title">Sign in to your account</p>
                <p className="ms-font-l -message">Welcome to MailMerge365. You are currently signed-out. Click the button below to sign-in.</p>

                <PrimaryButton
                    target="_blank"
                    onClick={() => onSignIn()}
                >Sign in</PrimaryButton>

                <p style={{ "paddingTop": "1em" }}><a href="https://mm365.me/help" target="_blank">More Information</a></p>
            </Wrapper>
        );
    }
}
